import { getReserveTotal, useUserMemoryAnimationReserve } from 'api/goodtrust/user/memory'
import { Spinner } from 'components/spinner/Spinner'
import Router, { useRouter } from 'next/router'
import { encodeQuery } from 'utils/fetcher'
import { Button } from 'components/button/Button'
import { css } from '@emotion/react'
import { Icon } from 'components/icon'

export function RemainingAnimations(props: { className?: string }) {
  const router = useRouter()
  const reserveData = useUserMemoryAnimationReserve().data?.json
  const count = getReserveTotal(reserveData)

  return (
    <Button
      type="button"
      size={['small', 'medium', 'large']}
      className={props.className}
      onClick={() =>
        void Router.push(
          encodeQuery('/subscription/animations', {
            next: router.asPath.split('?')[0],
          })
        )
      }
      leftIcon={<Icon name="Layers" />}
      css={css`
        text-align: start;
      `}
    >
      {count !== undefined ? (
        <>
          {`${count} animations left`}
          <br />
          Buy more now
        </>
      ) : (
        <Spinner />
      )}
    </Button>
  )
}
